'use strict';

/**
 * German (de-DE) — also used for de-AT / de-CH via language fallback.
 * Keep keys identical to en-AU.js.
 */
module.exports = {
  login: {
    trustLine:
      'Das Vertrauen von Teams in regulierten Berufen weltweit — überall dort, wo schwierige Gespräche zählen.',
    pitchTitle: 'Echte Gespräche, bevor sie echt sind.',
    pitchBody:
      'Üben Sie die schwierigen Gespräche — den Einwand, die Diagnose, die schlechte Nachricht — und erhalten Sie Feedback, solange es noch zählt.',
    orgManagedSignIn: 'Die Anmeldung wird von Ihrer Organisation verwaltet.',
    orgOnAudirie: '{name} auf Audirie',
    welcomeBack: 'Willkommen zurück.',
    findYourWayIn: 'Lassen Sie uns Ihren Zugang finden.',
    startWithWorkEmail: 'Beginnen Sie mit Ihrer dienstlichen E-Mail — wir führen Sie den richtigen Weg.',
    workEmailTellsUs:
      'Ihre dienstliche E-Mail zeigt uns, wie sich Ihre Organisation anmeldet. Kein Passwort nötig, wenn Single Sign-On genutzt wird.',
    workEmail: 'E-Mail-Adresse',
    continue: 'Weiter',
    pickUpWhereLeftOff: 'Machen Sie genau dort weiter, wo Sie aufgehört haben.',
    continueAs: 'Fortfahren als {email}',
    singleSignOn: 'Single Sign-On',
    singleSignOnWithOrg: 'Single Sign-On · {orgName}',
    audiriePassword: 'Audirie-Passwort',
    useDifferentAccount: 'Anderes Konto verwenden',
    oneMoment: 'Einen Moment…',
    checkingOrganisationSignIn: 'Wir prüfen, wie sich Ihre Organisation anmeldet.',
    whichOrgHeading: 'Als welche Organisation melden Sie sich an?',
    belongsToMultipleOrgs: '{email} gehört zu mehr als einer Organisation auf Audirie.',
    yourOrganisation: 'Ihre Organisation',
    useDifferentEmail: 'Andere E-Mail verwenden',
    orgTakesItFromHere: '{name} übernimmt ab hier',
    yourOrgTakesItFromHere: 'Ihre Organisation übernimmt ab hier',
    openingTheirSignIn:
      'Wir öffnen deren Anmeldeseite — Sie schließen dort ab und kommen direkt zurück. Nichts, was Sie dort eingeben, erreicht uns.',
    notYouStartAgain: 'Nicht Sie? Neu starten',
    verifiedGettingReady: 'Sie sind verifiziert. Ihr Übungsbereich wird vorbereitet.',
    orgSignInComplete: 'Anmeldung bei {name} abgeschlossen',
    accountNotReady: 'Ihr Konto ist noch nicht bereit',
    ssoWorkedButNeedsSetup:
      'Single Sign-On hat funktioniert, aber Ihr Audirie-Konto muss noch eingerichtet werden, bevor Sie eintreten können.',
    noRoleAssigned:
      'Ihrem Konto ist noch keine Rolle zugewiesen. Bitte wenden Sie sich an den Administrator Ihrer Organisation.',
    backToLogin: 'Zurück zur Anmeldung',
    orgDidntLetUsIn: '{name} hat uns nicht hereinlassen',
    couldntCompleteSso: 'Single Sign-On konnte nicht abgeschlossen werden',
    orgSignInDeclined:
      'Der Anmeldedienst Ihrer Organisation hat die Anfrage abgelehnt oder nicht geantwortet. Mit Ihrem Audirie-Konto ist alles in Ordnung.',
    ifKeepsHappening:
      'Wenn das weiterhin passiert, informieren Sie Ihr IT-Team — und schreiben Sie uns an support@audirie.com, damit wir helfen können.',
    tryAgain: 'Erneut versuchen',
    orgSignedInAsSomeoneElse: '{name} ist mit einem anderen Konto angemeldet',
    differentAccountSignedIn: 'Ein anderes Konto ist angemeldet',
    orgSignOnConnectedElsewhere:
      'Die Anmeldung Ihrer Organisation ist in diesem Browser noch mit einer anderen E-Mail verbunden.',
    signOutCorporateFirst:
      'Melden Sie sich zuerst von diesem Unternehmenskonto ab und versuchen Sie es dann erneut mit der gewünschten E-Mail.',
    enterPassword: 'Geben Sie Ihr Passwort ein',
    change: 'ändern',
    password: 'Passwort',
    forgotPassword: 'Passwort vergessen?',
    signIn: 'Anmelden',
    resetPassword: 'Passwort zurücksetzen',
    wellEmailLink: 'Wir senden Ihnen einen Link per E-Mail, um ein neues zu wählen.',
    send: 'Senden',
    cancel: 'Abbrechen',
    emailRequired: 'E-Mail ist erforderlich',
    emailAndPasswordRequired: 'E-Mail und Passwort sind erforderlich',
    emailNotFound: 'Diese E-Mail wurde nicht gefunden.',
    passwordIncorrect: 'Ihr Passwort ist falsch.',
    ssoUnavailable:
      'Single Sign-On ist derzeit nicht verfügbar. Bitte melden Sie sich mit Ihrem Passwort an.',
    popupBlocked:
      'Ihr Browser hat das Anmeldefenster blockiert. Erlauben Sie Pop-ups für diese Website und aktualisieren Sie dann die Seite, um fortzufahren.',
    couldNotLogIn:
      'Leider konnten wir Sie nicht anmelden. Schreiben Sie an support@audirie.com, wenn das Problem weiterhin besteht.',
    resetEmailSent:
      'Wenn die angegebene E-Mail-Adresse in unseren Unterlagen ist, erhalten Sie eine E-Mail mit einem Link zum Zurücksetzen Ihres Passworts.',
    needValidEmail: 'Bitte geben Sie eine gültige E-Mail-Adresse an.',
    mustRegisterFirst:
      'Sie müssen sich bei Audirie registrieren, bevor Sie diese Aufgabe abschließen können. Wenn Sie keinen Registrierungslink haben, kontaktieren Sie uns unter support@audirie.com',
    couldNotResetPassword:
      'Wir konnten Ihr Passwort nicht zurücksetzen. Bitte versuchen Sie es erneut. Wenn das Problem weiterhin besteht, kontaktieren Sie uns unter support@audirie.com'
  }
};
